import React,{useState,useEffect} from 'react';
import styled from 'styled-components';
import background from '../../static/images/dtms-intro.jpg';
import GetWindowDimentions from '../utils/Dimentions';
import {BannerButton} from '../button/index';

import './styles/style.css';
interface BannerConfig { 
  bannerWidth: number
  bannerHeight:number
}

interface BannerProps{
  isDisabled: boolean
}

const Background= styled.div<BannerConfig>`
background-image: url('${background}');
background-size:100% 100%;
background-repeat:no-repeat;
position:absolute;
top:0;
width:100%;
height:100%;
z-index:99999998;
cursor:pointer;
`

export const Banner = (props: BannerProps) => {
  const [windowDimentions,SetWindowDimentions] = useState<{width: number,height:number}>({width: 0,height: 0})
  const [renderNothing,SetRenderNothing] = useState<boolean>(false);
  const ChangeDimentions: EventListener = (event: Event) =>{
    let {width,height} = GetWindowDimentions();
    SetWindowDimentions({width,height})
  }
  useEffect(() => {
    window.addEventListener('resize',ChangeDimentions);
    return ()=>{
        window.removeEventListener('resize',ChangeDimentions);
    }
  }, [])

  useEffect(()=>{
    if(props.isDisabled) {
      setTimeout(()=>{
      SetRenderNothing(true);
       },1000)
    }
  },[props.isDisabled])
  
  if(renderNothing)
    return(
    <>
    </>)
  return (
      <>
      <div>
        <Background className={`${props.isDisabled ? 'banner--moveOut': 'banner--moveIn'}`} bannerWidth={windowDimentions.width} bannerHeight={windowDimentions.height} /> 
        <BannerButton className={`${props.isDisabled ? 'banner--moveOut': 'banner--moveIn'}`} > PRZEJDŹ <b>DO STRONY</b></BannerButton> 
      </div>
    
      </>
   )
} 